<template>
  <w-flex tag="footer" direction="col" align="stretch" class="actions-bar">
    <w-flex v-if="isSuperAdmin" class="actions-bar__row" justify="end">
      <w-flex align="center" :gap="4">
        <span class="font-small color-neutral-100"> Dla administratora: </span>

        <w-button-group variant="outlined">
          <w-button
            size="xs"
            color="neutral"
            class="header-nav-bar__title__button"
            text="Waliduj całość"
            @click="$emit('validate-all')"
          />
        </w-button-group>
      </w-flex>
    </w-flex>

    <w-flex class="actions-bar__row" align="center" justify="space-b">
      <w-button
        color="neutral"
        icon="exit_to_app"
        class="actions-bar__outlined-button"
        text="Wyjdź bez zapisu"
        @click="$emit('cancel')"
      />

      <w-flex align="center" :gap="4">
        <autosave-info :need-autosave="needAutosave" />

        <w-button-group variant="outlined">
          <w-button color="primary" text="Zapisz" @click="$emit('save', false)" />

          <w-button
            color="primary"
            icon="save"
            text="Zapisz i wyjdź"
            @click="$emit('save', true)"
          />
        </w-button-group>
      </w-flex>
    </w-flex>
  </w-flex>
</template>

<script setup lang="ts">
import AutosaveInfo from './AutosaveInfo.vue';

defineProps<{
  isSuperAdmin?: boolean;
  needAutosave?: boolean;
}>();

defineEmits({
  cancel: null,
  save: null,
  'validate-all': null,
});
</script>

<style lang="scss">
.actions-bar {
  background: w.color('neutral', 800);

  &__row {
    padding: 12px w.size('layout-padding');

    &:not(:last-child) {
      border-bottom: 1px solid w.color('neutral', 700);
    }
  }

  .w-button-group {
    &--outlined {
      border-color: w.color('neutral', 600);
    }
  }
}
</style>
